import { PinConfig, TableHeader } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { underlineTextStyles } from '~/components/tooltip-container/TooltipContainer.styles';

export const StyledTableHeader = styled(TableHeader)<{
  $hasDropdown: boolean;
  $isDraggable: boolean;
  $highlight: boolean;
  $isParentColumn: boolean;
  $top: number;
  $hasTooltip: boolean;
  $pinConfig?: PinConfig;
}>`
  position: sticky;
  top: ${props => props.$top + 'px'};
  z-index: var(--z-index-header-cell);
  cursor: ${props => (props.$hasDropdown ? 'pointer' : 'default')};
  background-color: ${props => props.$highlight && 'var(--text-inverse)'};
  border-bottom: ${props =>
    props.$isParentColumn ? 'none' : '1px solid var(--border-default)'};

  ${({ $pinConfig }) =>
    $pinConfig &&
    css`
      z-index: calc(var(--z-index-header-cell) + 1);
      left: ${$pinConfig.left}px;
      right: ${$pinConfig.right}px;
      top: 0;
    `}

  ${({ $pinConfig }) =>
    $pinConfig?.isLastPinned &&
    css`
      border-right: 1px solid var(--border-default);
    `}

  ${props =>
    props.$hasTooltip &&
    css`
      ${underlineTextStyles};
    `}
`;
